"use client";

import styles from "./AuthorizeRememberMeCheckbox.module.scss";
import { Checkbox } from "@vetty/ui";

/**
 * AuthorizeRememberMeCheckbox Component
 *
 * Checkbox for "Remember me" functionality in authorize form.
 * Allows users to stay logged in on the current device.
 */
export const AuthorizeRememberMeCheckbox = () => {
  /**
   * Handles checkbox state changes
   * Currently logs the value - should be connected to form state
   */
  const handleCheckboxChange = (checked: boolean) => {
    console.log(checked);
    // TODO: Connect to form state management
  };

  return (
    <div className={styles["comp"]}>
      <Checkbox
        id={"rememberMe"}
        key={"rememberMe"}
        onChange={handleCheckboxChange}
      >
        <Checkbox.Label>Remember me on this device</Checkbox.Label>
      </Checkbox>
    </div>
  );
};
